<div class="flex flex-col"
	style="background-image: url('/images/marble_texture.png'); background-size: cover; background-position: center;">

	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />

	<div class="flex flex-1 items-start justify-center px-8 py-10">
		<div class="w-full" style="max-width: 640px;">

			<div class="mb-8 text-center">
				<h1 style="font-family: var(--font-family-display); font-size: 1.5rem; font-weight: 600; letter-spacing: 0.12em; color: var(--color-aegean-700);">
					<span ro-i18n eikey="login.brandName">The Socrates Initiative</span>
				</h1>
				<div style="width: 60px; border-top: 1px solid var(--color-gold-500); margin: 8px auto;"></div>
			</div>

			<div class="rounded-lg shadow-2xl overflow-hidden"
				style="border: 6px solid var(--color-sandstone); outline: 1px solid var(--color-gold-500);">

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />

				<div style="background-image: url('/images/marble_texture.png'); background-size: cover; padding: 40px 50px 32px;">

					<h2 class="mb-6 text-2xl font-semibold" style="color: var(--color-charcoal); font-family: var(--font-family-display); letter-spacing: 0.03em;">
						<span ro-i18n eikey="profile.heading">My Profile</span>
					</h2>

					@if (loading()) {
						<div class="flex items-center gap-2 mb-4" style="color: var(--color-aegean-700);">
							<svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
								<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
								<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
							</svg>
							<span class="text-sm" ro-i18n eikey="general.loading">Loading…</span>
						</div>
					}

					@if (successMsg()) {
						<div class="mb-6 rounded border px-4 py-3 text-sm"
							style="border-color: var(--color-aegean-400); background-color: rgba(70,120,160,0.08); color: var(--color-aegean-700);">
							{{ successMsg() }}
						</div>
					}

					@if (saveError()) {
						<div class="mb-4 rounded border px-4 py-3 text-sm"
							style="border-color: var(--color-terra-500); background-color: rgba(195,90,60,0.08); color: var(--color-terra-600);">
							{{ saveError() }}
						</div>
					}

					@if (!loading()) {
						<form [formGroup]="profileForm" (ngSubmit)="onSubmit()" novalidate>

							<!-- ── Section: Identity ── -->
							<div class="mb-6">
								<h3 class="text-xs font-semibold uppercase tracking-widest mb-4" style="color: var(--color-gold-600); font-family: var(--font-family-display);">
									<span ro-i18n eikey="signup.section.identity">Your Information</span>
								</h3>

								<!-- First / Last -->
								<div class="flex gap-4 mb-4">
									<div class="flex-1">
										<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.field.firstName">First Name</span>
										</label>
										<input formControlName="firstName" type="text"
											class="w-full rounded border px-3 py-2 text-sm outline-none"
											[class.border-red-400]="profileForm.get('firstName').touched && profileForm.get('firstName').invalid"
											style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);" />
									</div>
									<div class="flex-1">
										<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.field.lastName">Last Name</span>
										</label>
										<input formControlName="lastName" type="text"
											class="w-full rounded border px-3 py-2 text-sm outline-none"
											[class.border-red-400]="profileForm.get('lastName').touched && profileForm.get('lastName').invalid"
											style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);" />
									</div>
								</div>

								<!-- Email (read-only) -->
								<div class="mb-4">
									<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="general.email">Email</span>
									</label>
									<input formControlName="email" type="email"
										class="w-full rounded border px-3 py-2 text-sm outline-none"
										style="border-color: var(--color-sandstone); background-color: rgba(233,225,211,0.4); color: var(--color-charcoal); opacity: 0.7; cursor: not-allowed;" />
									<p class="mt-1 text-xs opacity-60" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="profile.emailNote">Email cannot be changed here. Contact your administrator.</span>
									</p>
								</div>
							</div>

							<!-- ── Section: Preferences ── -->
							<div class="mb-6">
								<h3 class="text-xs font-semibold uppercase tracking-widest mb-4" style="color: var(--color-gold-600); font-family: var(--font-family-display);">
									<span ro-i18n eikey="signup.section.preferences">Preferences</span>
								</h3>

								<!-- Timezone -->
								<div class="mb-4">
									<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="signup.prefs.timezone">Timezone</span>
									</label>
									<select formControlName="timezone"
										class="w-full rounded border px-3 py-2 text-sm outline-none"
										style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal); font-family: var(--font-family-ui);">
										@for (tz of timezones; track tz) {
											<option [value]="tz">{{ tz }}</option>
										}
									</select>
								</div>

								<!-- Notification preferences -->
								<p class="mb-2 text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
									<span ro-i18n eikey="signup.prefs.notificationsLabel">Email me when:</span>
								</p>
								<div class="flex flex-col gap-2">
									<label class="flex items-center gap-3 cursor-pointer">
										<input type="checkbox" formControlName="notifyFloorEvents"
											class="h-4 w-4 rounded flex-shrink-0"
											style="accent-color: var(--color-aegean-700);" />
										<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.prefs.notifyFloorEvents">An idea I'm following moves to or off the Floor</span>
										</span>
									</label>
									<label class="flex items-center gap-3 cursor-pointer">
										<input type="checkbox" formControlName="notifyObjections"
											class="h-4 w-4 rounded flex-shrink-0"
											style="accent-color: var(--color-aegean-700);" />
										<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.prefs.notifyObjections">An objection is raised or resolved on a contribution I'm involved with</span>
										</span>
									</label>
									<label class="flex items-center gap-3 cursor-pointer">
									<input type="checkbox" formControlName="notifyDiscussion"
										class="h-4 w-4 rounded flex-shrink-0"
										style="accent-color: var(--color-aegean-700);" />
									<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="signup.prefs.notifyDiscussion">Someone replies to a contribution I'm involved with</span>
									</span>
								</label>
								@if (!isActiveMember) {
									<label class="flex items-center gap-3 cursor-pointer">
										<input type="checkbox" formControlName="notifyDecisions"
											class="h-4 w-4 rounded flex-shrink-0"
											style="accent-color: var(--color-aegean-700);" />
										<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.prefs.notifyDecisions">A membership decision is made on my application</span>
										</span>
									</label>
								}
								</div>
							</div>

							<!-- ── Submit ── -->
							<div style="border-top: 1px solid var(--color-sandstone); padding-top: 20px;">
								<div class="flex items-center justify-between">
									<button type="button" (click)="onCancel()"
										class="text-xs transition-colors"
										style="color: var(--color-aegean-600); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="profile.backToDashboard">Back to Dashboard</span>
									</button>
									<button type="submit"
										[disabled]="saving()"
										class="rounded px-6 py-2.5 text-sm font-semibold tracking-wide shadow transition-colors disabled:cursor-not-allowed disabled:opacity-50"
										style="background-color: var(--color-aegean-600); color: var(--color-marble); font-family: var(--font-family-display); letter-spacing: 0.06em;">
										@if (saving()) {
											<span class="flex items-center gap-2">
												<svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
													<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
													<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
												</svg>
												<span ro-i18n eikey="general.saving">Saving…</span>
											</span>
										} @else {
											<span ro-i18n eikey="general.save">Save</span>
										}
									</button>
								</div>
							</div>

						</form>
					}

				</div>

				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />
			</div>

		</div>
	</div>

	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />
</div>
